import { LeagueRow } from '../../../components/LeaguesList'
import type { League } from '../../../types'
import DemoFrame from './DemoFrame'
import { demoNoop } from './demoFixtures'

/**
 * Two mini-league rows, frozen with a rank that moved up and one that moved down, so the rank rail
 * — the movement arrow beside the number — reads without a caption.
 *
 * Both rows are `type: 'mini'` on purpose: the Global league is not a mini-league, and putting it
 * in this visual would conflate the two exactly where the copy is trying to separate them.
 */
function demoLeague(
  id: string,
  name: string,
  memberCount: number,
  yourRank: number,
  movementDelta: number,
  leaderName: string
): League {
  return {
    id,
    name,
    type: 'mini',
    isSystemLeague: false,
    joinPolicy: 'request',
    memberCount,
    yourRank,
    previousRank: yourRank + movementDelta,
    createdBy: null,
    standings: [
      { id: `${id}-leader`, name: leaderName, points: 214 },
      { id: `${id}-you`, name: 'You', points: 198, isYou: true, movementDelta },
    ],
  }
}

const DEMO_LEAGUES = [
  demoLeague('demo-pub', 'Sunday Pub XI', 12, 2, 1, 'Marcus'),
  demoLeague('demo-office', 'The Office League', 34, 9, -2, 'Priya'),
]

export default function LeaguesDemo() {
  return (
    <DemoFrame className="rules-demo--leagues">
      {DEMO_LEAGUES.map((league) => (
        <LeagueRow key={league.id} league={league} onSelect={demoNoop} />
      ))}
    </DemoFrame>
  )
}
